<div class="breadcrumb-container">
    <div class="row">
        <div class="col-lg-12">
            <h1>Language Packs</h1>
            <ol class="breadcrumb" id="breadcrumbNav">
                <li>
                    <a [routerLink]="['/home']">
                        <i class="fa fa-home "></i>
                        <span>ProManual </span>
                    </a>
                </li>
                <li class="active">
                    <i class="fa fa-pencil"></i>
                    <span>Language Packs </span>
                </li>
            </ol>
        </div>
    </div>
</div>
<div class="component-container">

    <div class="well" style="height: 100%;">
        <div class="row" style="height: 100%; overflow: hidden;">
            <div class="panel panel-info" style="height: 100%">
                <div class="panel-heading">
                    <h4>Known Languages</h4>
                    <h6>If a language is not displayed, ensure it exists in Code Management.  The Language Pack must be in XML format and will be validated upon upload.</h6>
                </div>
                <div class="panel-body" style="height: 90%; padding-bottom: 110px;">
                    <div class="list-group" style="height: 100%; overflow-y: scroll;">
                        <div class="list-group-item" *ngFor="let language of languages">
                            <div class="row">
                                <div class="col-lg-4">
                                    {{ language.Part }} - {{ language.Value }}
                                </div>
                                <div class="col-lg-2">
                                    Last Updated By: {{ language.ModifiedBy ? language.ModifiedBy : ''  }}
                                </div>
                                <div class="col-lg-2">
                                    Last Updated: {{ language.Detail?.Updated | amDateFormat: 'MM/DD/YYYY' }}
                                </div>
                                <div class="col-lg-2">
                                    <a class="btn btn-primary btn-sm btn-block" [attr.title]="language.Detail ? 'Download Pack for Translation' : 'Download Language Pack'" [attr.href]="getLink(language)">
                                        <span data-toggle="tooltip" class="fa fa-download fa-lg fa-fw"></span>
                                        {{ language.Detail ? 'Download Pack for Translation' : 'Download Language Pack' }}
                                    </a>
                                </div>
                                <div class="col-lg-2">
                                    <button type="button" class="btn btn-primary btn-sm btn-block" title="Upload Language Pack" (click)="upload(language)">
                                        <span data-toggle="tooltip" class="fa fa-upload fa-lg"></span>
                                        <span>Upload Language Pack</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div bsModal #uploadPackModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" aria-hidden="true" (click)="close()">&times;</button>
                <h4 class="modal-title" id="myModalLabel">
                    Upload Language Pack &bull; {{ pack.Value }}
                </h4>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-md-9">
                        <input id="logoToUpload" name="logoToUpload" class="form-control form-control-static" placeholder="Choose File" disabled="disabled" [(ngModel)]="filename" />
                    </div>
                    <div class="col-md-2">
                        <div class="fileUpload btn btn-info">
                            <span>Choose File</span>
                            <input id="uploadLogoButton" class="upload" type="file" accept=".xml" (change)="preUpload($event)" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="close()">Close</button>
                <button type="button" class="btn btn-primary" (click)="uploadFile()">Upload</button>
            </div>

        </div>
    </div>
</div>